import { render, staticRenderFns } from "./ToolheadCard.vue?vue&type=template&id=0f8c7c21&"
import script from "./ToolheadCard.vue?vue&type=script&lang=ts&"
export * from "./ToolheadCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports